import axios from "axios";
import { getCookie, objToParams } from "@/helpers/helpers";

export default {
    async requestFiles({ commit }, params = {}) {
        commit('loadingFiles');

        try {
            //Alteração Teste - Pesquisa 29-04-2024
            //const response = await axios.get(`${process.env.VUE_APP_BACKEND_API}/unity/files/${objToParams(params)}`);
            const response = await axios.get(`${process.env.VUE_APP_BACKEND_API}/unity/files${objToParams(params)}`);
            commit('successFiles', response.data);
            commit('resetSuccessFiles');
            return true;
        } catch(error) {
            commit('errorFiles', error.response.data);
            return false;
        }
    },
};
